import { type ErrorLike } from "@apollo/client";
import { Css, useTestIds } from "@homebound/beam";
import { ErrorMessages } from "src/components/ErrorMessages";
import { SuggestedPaths } from "src/components/SuggestedPaths";

/** Displays an unexpected application error and recovery links. */
export function Error(props: { error: ErrorLike }) {
  const { error } = props;
  const tid = useTestIds({});
  return (
    <div css={Css.tac.mt4.wPx(600).mxa.$} {...tid.errorPage}>
      <img src="/images/error.jpg" css={Css.bshHover.my2.wPx(400).mxa.$} alt="" />
      <h1 css={Css.xl2.mb4.$} {...tid.title}>
        &#x1F914; Something doesn't seem quite right here&hellip;
      </h1>
      <ErrorMessages error={error} />
      <SuggestedPaths error={error} />
    </div>
  );
}
